import {
  getMutationOperationInputProperties,
  getMutationOperationOutputProperties
} from "@specs"

import getInput from "./getInput"


const getMutationSchema = operation => {
  const isUpdateOperation = !operation.includes("/Create")

  const propertiesMap = getMutationOperationInputProperties(operation)

  const properties = []
  for (const key of Object.keys(propertiesMap)) {
    properties.push({ ...propertiesMap[key], name: key })
  }

  const schema = properties.map(property => getInput(operation, property))

  if (isUpdateOperation) {
    const outputPropertiesMap = getMutationOperationOutputProperties(operation)

    for (const property of schema) {
      const { name: key } = property
      const outputProperty = outputPropertiesMap[key]

      property.required = outputProperty ? (outputProperty.isRequired || false) : property.required
    }
  }

  return schema
}

export default getMutationSchema
